










import { Component, Prop, Vue } from 'vue-property-decorator'
import { Exercise } from '@/interfaces'

@Component
export default class ExerciseList extends Vue {
  @Prop({ default: [] }) exercises!: Exercise[]
}
